import React from "react";
import Head from "next/head";

import AirmilesMain from "@/components/airmiles/airmiles-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const Airmiles = () => {
  return (
    <>
      <Head>
        <title>{seoData.AIR_MILES_GUEST.title}</title>
        <SeoMetaData data={seoData.AIR_MILES_GUEST} />
      </Head>
      <AirmilesMain />
    </>
  );
};

export default Airmiles;
